<template>
  <div>
    <!-- ─── Main Header ─────────────────────────────────── -->
    <header
      class="new-header"
      :class="{
        'header-hidden-mobile': showresumeclinic && !loginModalOpen,
        'header-over-modal': showresumeclinic && loginModalOpen,
        'border-bottom-unset': searchActive,
      }"
    >
      <div
        v-if="spinnerStatus"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 1;
          backdrop-filter: blur(2px);
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <Spinner />
      </div>
      <div class="header-main">
        <div class="head-div d-flex gap-3">
          <img
            id="hideinlaptop"
            @click="openMobileMenu()"
            src="../../assets/guestHeader/hamburger.svg"
            alt="Menu"
          />
          <img
            class="logo pointer"
            @click="goToHire3xHome()"
            src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
            alt="Hire3x Logo"
          />
        </div>
        <div :class="{ 'extra-div': searchActive }"></div>
        <!-- <div id="hideinmobile" class="color-4A7EFF font-inter fw-500 fs-16">
        Find Mentor
      </div> -->

        <!-- Expanded Search Container -->
        <div class="header-center-area lap-pl-5" ref="searchContainer">
          <!-- Tabs -->
          <div
            class="search-tabs-container"
            :class="{ 'is-active': searchActive }"
          >
            <div
              class="search-tab"
              :class="{ active: selectedTab == 'job' }"
              @click="selectTab('job')"
            >
              Jobs
            </div>
            <span class="divider">|</span>
            <div
              class="search-tab"
              :class="{ active: selectedTab == 'assessment' }"
              @click="selectTab('assessment')"
            >
              Assessments
            </div>
            <span class="divider">|</span>
            <div
              class="search-tab"
              :class="{ active: selectedTab == 'course' }"
              @click="selectTab('course')"
            >
              Courses
            </div>
          </div>

          <!-- Search Bar -->
          <div
            class="search-bar-wrapper"
            :class="{ 'is-active': searchActive }"
          >
            <div
              class="d-flex gap-2 w-100 search-inner-container mobsearchpadding"
            >
              <img
                id="hideinlaptop"
                @click="closeSearchDropdown"
                class="shadow"
                src="../../assets/guestHeader/search-back.svg"
                alt="Close Search"
              />
              <div class="d-flex w-100 justify-content-center">
                <div
                  class="header-search"
                  @click.stop="
                    openSearchDropdown();
                    $refs.searchInput.focus();
                  "
                >
                  <b-form-input
                    autocomplete="off"
                    v-model="searchQuery"
                    placeholder="Search.."
                    ref="searchInput"
                    @focus="openSearchDropdown()"
                    @input="onSearchInput"
                    @keyup.enter="handleEnterSearch"
                  ></b-form-input>
                  <img
                    src="../../assets/guestHeader/darksearchicon.svg"
                    alt="Search Icon"
                  />
                </div>
              </div>
            </div>

            <!-- Search Dropdown Content Component -->
            <SearchDropdown
              v-if="searchActive"
              :isVisible="searchActive"
              :selectedTab="selectedTab"
              :searchQuery="searchQuery"
              :searchSuggestion="searchSuggestion"
              :isSearching="isSearchLoading"
              @close-modal="closeSearchDropdown"
              @open-login-modal="openingLoginModal"
              @open-resume-clinic="openResumeClinicModal"
            />
          </div>
        </div>

        <!-- Overlay to close search dropdown -->
        <div class="search-overlay" v-if="searchActive"></div>

        <!-- Mobile: search icon -->
        <div id="hideinlaptop" class="d-flex align-items-center">
          <div @click.stop="openMobileSearch()">
            <img src="../../assets/guestHeader/search.svg" alt="Search" />
          </div>
        </div>

        <!-- Desktop action buttons -->
        <div
          id="hideinmobile"
          class="header-btns d-flex gap-16px align-items-center"
        >
          <!-- Notification bell (desktop only) -->
          <div class="pointer" @click="openNotificationPanel()">
            <img src="../../assets/guestHeader/guestheader-noti.svg" alt="" />
          </div>
          <b-button @click="goToHire3xAdminHome()" class="header-for-biz-btn">
            <img
              src="../../assets/guestHeader/forBusiness.svg"
              alt="For Business Icon"
            />
            For Business
          </b-button>
          <b-button
            @click="openCandidateLoginModal()"
            class="candash-addBtn padding813px"
            >Login
            <img
              src="../../assets/guestHeader/loginArrow.svg"
              alt="Login Arrow"
          /></b-button>
        </div>
      </div>
    </header>

    <!-- ─── Notification Slide Panel ──────────────────────── -->
    <transition name="notif-slide">
      <div v-if="notifOpen" class="notif-panel">
        <div class="notif-panel-header">
          <span class="notif-panel-title">Notifications</span>
          <button class="notif-close-btn" @click="notifOpen = false">✕</button>
        </div>

        <div class="notif-list">
          <div v-for="(notif, i) in notifications" :key="i" class="notif-card">
            <div
              class="notif-card-body pointer"
              @click="handleNotifAction(notif)"
            >
              <img class="notif-avatar" :src="notif.avatar" :alt="notif.name" />
              <div class="notif-text">
                <p class="notif-name">{{ notif.name }}</p>
                <p class="notif-msg">{{ notif.message }}</p>
                <button
                  v-if="notif.cta"
                  class="notif-cta"
                  @click.stop="handleNotifAction(notif)"
                >
                  {{ notif.cta }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="notifications.length === 0" class="notif-empty">
            You're all caught up! 🎉
          </div>
        </div>
      </div>
    </transition>

    <!-- Overlay to close notification panel -->
    <div
      v-if="notifOpen"
      class="notif-overlay"
      @click="notifOpen = false"
    ></div>

    <!-- ─── Mobile Menu Drawer ──────────────────────── -->
    <transition name="slide-left">
      <div v-if="isMobileMenuOpen" class="mobile-drawer-menu">
        <div class="drawer-header">
          <div class="d-flex align-items-center gap-2">
            <img
              @click="goToHire3xHome()"
              class="logo"
              src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
              alt="Hire3x Logo"
            />
          </div>
          <button class="drawer-close" @click="isMobileMenuOpen = false">
            ✕
          </button>
        </div>

        <div class="drawer-scroll-area">
          <nav class="drawer-nav">
            <div class="drawer-link" @click="handleDrawerClick('Interviews')">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-mock-interview.svg"
                  alt="Mock Interviews Icon"
                />
              </div>
              Mock Interviews
            </div>
            <div class="drawer-link" @click="handleDrawerClick('Fix Resume')">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-resume-clinic.svg"
                  alt="Resume Clinic Icon"
                />
              </div>
              Resume Clinic
            </div>
            <div class="drawer-link" @click="handleDrawerClick('Assessment')">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-mock-assess.svg"
                  alt="Mock Assessments Icon"
                />
              </div>
              Mock Assessments
            </div>
            <div class="drawer-link" @click="handleDrawerClick('Jobs')">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-find-job.svg"
                  alt="Find Jobs Icon"
                />
              </div>
              Find Jobs
            </div>
            <div class="drawer-link" @click="handleDrawerClick('Courses')">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-find-course.svg"
                  alt="Find Courses Icon"
                />
              </div>
              Find Courses
            </div>
          </nav>

          <div class="drawer-divider"></div>

          <nav class="drawer-nav">
            <div class="drawer-link" @click="TriggereRegisterModal()">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-register.svg"
                  alt="Register Icon"
                />
              </div>
              Register- As a Candidate
            </div>
            <div class="drawer-link" @click="goToReuqest()">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-business.svg"
                  alt="Business Icon"
                />
              </div>
              Business- Request a Demo
            </div>
            <div class="drawer-link" @click="goToPlaystore()">
              <div class="drawer-icon-placeholder">
                <img
                  src="../../assets/guestHeader/s-get-app.svg"
                  alt="Get App Icon"
                />
              </div>
              Get our App
            </div>
          </nav>
        </div>

        <footer class="drawer-footer">
          <div class="drawer-banner mb-4" @click="goToHire3xAdminHome()">
            <div class="w-100">
              <img
                class="w-100"
                src="../../assets/guestHeader/s-banner.svg"
                alt="App Promotional Banner"
              />
            </div>
          </div>
          <!-- <button class="main-blue-btn w-100">Log out</button> -->
          <button
            class="main-blue-btn w-100"
            @click="openCandidateLoginModal()"
          >
            Login
          </button>
        </footer>
      </div>
    </transition>
    <ResumeClinicModal
      v-if="showresumeclinic"
      :showModal="showresumeclinic"
      @modalClose="modalClose"
      @resumeUploaded="resumeAnalysis"
      @openLoginModal="openLoginModal"
      @openLoginModalWithJobID="openLoginModalWithJobID"
      :showfromhelpsection="false"
      :clinicDatafromhs="resumeClinicData"
    />

    <div
      v-if="isMobileMenuOpen"
      class="drawer-overlay"
      @click="isMobileMenuOpen = false"
    ></div>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import Spinner from "@/components/fixedComponents/Spinner.vue";
import SearchDropdown from "./SearchDropdown.vue";
import { eventBus } from "@/utils/eventBus";
import { appConfig } from "@/config/appConfig";
import ResumeClinicModal from "@/components/modals/ResumeClinicModal.vue";
import {
  getAccess,
  openLoginModal,
  ensureGuestUUID,
  clearGuestUUID,
} from "@/utils/tokenCheck";
import globalSearchMixin from "@/utils/mixins/globalSearchMixin";
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig";
import heeraNotificationMixin from "@/utils/mixins/heeraNotificationMixin";

export default {
  components: {
    SearchDropdown,
    ResumeClinicModal,
    Spinner,
  },
  mixins: [globalSearchMixin, heeraNotificationMixin],
  data() {
    return {
      spinnerStatus: false,
      jobId: null,
      uuid: null,
      userType: "candidate",
      candidateBase: appConfig.candidateBase,
      websiteBase: appConfig.websiteBase,
      trainingBase: appConfig.trainingBase,

      isMobileMenuOpen: false,
      searchActive: false,
      selectedTab: "job",
      searchQuery: "",
      searchSuggestion: [],
      showresumeclinic: false,
      loginModalOpen: false,
      resumeClinicData: {},
    };
  },
  created() {
    this.loadNotifications();
    eventBus.$on("spinner-start", this.onSpinnerStart);
  },
  mounted() {
    this.onCloseResumeClinic = () => {
      this.showresumeclinic = false;
    };
    this.onCloseHeaderSearch = () => {
      this.closeSearchDropdown();
    };
    this.onCloseMobileMenu = () => {
      this.isMobileMenuOpen = false;
    };
    document.addEventListener("mousedown", this.onDocumentClick);
    this.onLoginModalOpened = () => {
      this.loginModalOpen = true;
    };
    this.onLoginModalClosed = () => {
      this.loginModalOpen = false;
    };
    eventBus.$on("close-mobile-menu", this.onCloseMobileMenu);
    eventBus.$on("close-header-search", this.onCloseHeaderSearch);
    eventBus.$on("close-resume-clinic", this.onCloseResumeClinic);
    eventBus.$on("open-login-modal", this.onLoginModalOpened);
    eventBus.$on("close-login-modal", this.onLoginModalClosed);
    this.onWindowFocus = () => {
      this.loadNotifications();
    };
    window.addEventListener("focus", this.onWindowFocus);
  },
  computed: {
    isLoggedIn() {
      return localStorage.getItem("vue_token") ? true : false;
    },
  },
  watch: {
    $route() {
      this.closeSearchDropdown();
    },
    searchActive(val) {
      if (val || this.notifOpen || this.isMobileMenuOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
    isMobileMenuOpen(val) {
      if (val || this.searchActive || this.notifOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      eventBus.$emit("mobile-menu-state", val);
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    document.removeEventListener("mousedown", this.onDocumentClick);
    window.removeEventListener("focus", this.onWindowFocus);
    eventBus.$off("close-resume-clinic", this.onCloseResumeClinic);
    eventBus.$off("open-login-modal", this.onLoginModalOpened);
    eventBus.$off("close-login-modal", this.onLoginModalClosed);
  },
  methods: {
    onDocumentClick(event) {
      const searchContainer = this.$refs.searchContainer;
      if (searchContainer && !searchContainer.contains(event.target)) {
        this.closeSearchDropdown();
      }
    },
    openNotificationPanel() {
      if (this.searchActive) {
        this.closeSearchDropdown();
      }
      this.notifOpen = true;
    },
    goToPlaystore() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.hire3x.candidate";
    },
    goToReuqest() {
      window.location.href = `${this.websiteBase}/requestdemo`;
    },
    TriggereRegisterModal() {
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
      }
      openLoginModal({ mode: "register" });
    },
    openMobileSearch() {
      if (this.notifOpen) {
        this.notifOpen = false;
      }

      const loginModal = document.getElementById("loginModal");
      const isLoginModalOpen =
        loginModal &&
        loginModal.classList.contains("show") &&
        loginModal.getAttribute("aria-hidden") !== "true";

      if (isLoginModalOpen) {
        eventBus.$emit("close-login-modal");
      }

      this.searchActive = true;
    },
    openMobileMenu() {
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        return;
      }

      if (this.notifOpen) {
        this.notifOpen = false;
      }

      const loginModal = document.getElementById("loginModal");
      const isLoginModalOpen =
        loginModal &&
        loginModal.classList.contains("show") &&
        loginModal.getAttribute("aria-hidden") !== "true";

      if (isLoginModalOpen) {
        eventBus.$emit("close-login-modal");
      }
      this.isMobileMenuOpen = true;
    },

    goToHire3xAdminHome() {
      window.location.href = `${this.websiteBase}/home`;
    },
    goToHire3xHome() {
      window.location.href = `${this.websiteBase}`;
    },
    async onSpinnerStart() {
      this.spinnerStatus = true;
      setTimeout(() => {
        this.spinnerStatus = false;
      }, 3000);
      this.$forceUpdate();
    },
    openLoginModal(uuid) {
      this.$store.commit("userVUEX/setresumeClinicuid", uuid);
      this.$store.commit("userVUEX/setresumeJobid", null);
      this.openingLoginModal();
    },
    openLoginModalWithJobID(jobId, uuid) {
      this.$store.commit("userVUEX/setresumeClinicuid", uuid);
      this.$store.commit("userVUEX/setresumeJobid", jobId);
      this.openingLoginModal();
    },

    openingLoginModal() {
      eventBus.$emit("open-login-modal");
    },
    openCandidateLoginModal() {
      if (this.searchActive) {
        this.closeSearchDropdown();
      }
      this.userType = "candidate";
      console.log("Opening candidate login modal...");
      this.isMobileMenuOpen = false; // Close mobile menu if open
      eventBus.$emit("open-login-modal");
    },

    selectTab(data) {
      this.selectedTab = data;
      this.searchQuery = "";
      this.searchSuggestion = [];
    },
    openSearchDropdown() {
      this.searchActive = true;
    },
    closeSearchDropdown() {
      this.searchActive = false;
      this.selectedTab = "job";
      this.searchQuery = "";
      this.searchSuggestion = [];
      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur();
      }
    },
    handleLoggedOutExploreClick(item) {
      this.isMobileMenuOpen = false;
      switch (item) {
        case "Resume":
          this.$store.commit("setLoginModalOpen", true);
          break;
        case "Interviews":
          window.location.href = `${this.websiteBase}/#mockinterviews`;

          break;
        case "Jobs":
          window.location.href = `${this.websiteBase}/#jobs`;

          break;
        case "Courses":
          window.location.href = `${this.websiteBase}/#courses`;

          break;
        case "Roadmap":
          window.location.href = `${this.websiteBase}/#mockinterviews`;

          break;
        case "Assessment":
          window.location.href = `${this.websiteBase}/#assessments`;

          break;
        case "Fix Resume":
          this.openResumeClinicModal();
          break;
        case "Register":
          this.$store.commit("setLoginModalOpen", true);
          break;
        case "Business":
          this.$router.push("/");
          break;
        case "Get App":
          window.open(`${this.websiteBase}`);
          break;
      }
    },
    handleExploreClick(item) {
      this.isMobileMenuOpen = false;
      switch (item) {
        case "Resume":
          window.open(`${this.candidateBase}/dashboard?from=candidate`);

          break;
        case "Interviews":
          window.open(`${this.candidateBase}/prepareinterview?from=candidate`);

          break;
        case "Jobs":
          window.open(`${this.candidateBase}/job/search?from=candidate`);

          break;
        case "Courses":
          window.open(`${this.trainingBase}/marketplace`);

          break;
        case "Roadmap":
          window.open(`${this.candidateBase}/prepareinterview?from=candidate`);

          break;
        case "Assessment":
          window.open(`${this.candidateBase}/assessments?from=candidate`);

          break;
        case "Fix Resume":
          this.openResumeClinicModal();
          break;
        case "Register":
          this.$router.push("/dashboard");
          break;
        case "Business":
          this.$router.push("/");
          break;
        case "Get App":
          window.open(`${this.websiteBase}`);

          break;
      }
    },
    handleDrawerClick(item) {
      if (this.isLoggedIn) {
        this.handleExploreClick(item);
      } else {
        this.handleLoggedOutExploreClick(item);
      }
    },
    logout() {
      this.isMobileMenuOpen = false;
      this.$store.dispatch("userVUEX/LogOut");
      clearGuestUUID();
      this.$router.push("/");
      localStorage.clear();
      // location.reload();
    },
    async openResumeClinicModal() {
      this.showresumeclinic = true;
    },
    modalClose() {
      this.showresumeclinic = false;
      if (this.$route.query?.from === "resumeclinicModal") {
        window.history.replaceState({}, "", this.$route.path);
      }
    },
  },
};
</script>

<style scoped>
.padding813px {
  width: 125px;
  font-family: "Inter", sans-serif;
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #ffffff !important;
  height: 40px;
  padding: 8px 24px !important;
  justify-content: center;
}
.gap-16px {
  gap: 16px;
}
.header-hidden-mobile {
  display: none !important;
}
/* Mobile Drawer Transitions */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}

.mobile-drawer-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 90%;
  max-width: 380px;
  height: 100vh;
  background: #ffffff;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #efefef;
}

.drawer-header .logo {
  height: 23px;
}

.drawer-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #4a7eff;
  cursor: pointer;
  padding: 0;
}

.drawer-scroll-area {
  /* flex: 1; */
  height: calc(100dvh - 260px);
  overflow-y: auto;
  padding: 10px 0;
}

.drawer-nav {
  display: flex;
  flex-direction: column;
}

.drawer-link {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 24px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  cursor: pointer;
  transition: background 0.2s;
}

.drawer-link:hover {
  background: #f8f9fa;
}

.drawer-icon-placeholder {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* User can put svg inside drawer-icon-placeholder */
.drawer-icon-placeholder svg {
  width: 100%;
  height: 100%;
}

.drawer-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 12px 0;
}

.drawer-banner {
  padding-inline: 0;
}

.drawer-footer {
  padding: 20px 24px;
}

.drawer-logout-btn {
  width: 100%;
  padding: 12px;
  border-radius: 25px;
  border: 1px solid #4a7eff;
  background: #ffffff;
  color: #4a7eff;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.drawer-logout-btn:hover {
  background: #4a7eff;
  color: #ffffff;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.main-wrapper-website {
  background-color: #ffffff;
}
.new-header {
  background-color: #ffffff;
  height: 72px;
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #efefef;
  backdrop-filter: blur(50px);
  position: fixed;
  width: 100%;
  z-index: 999;
  padding: 0px 30px;
}
.new-header.border-bottom-unset {
  border-bottom: unset;
}

.header-main {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
.header-for-biz-btn {
  width: 170px;
  white-space: nowrap;
  padding: 8px 24px !important;
  height: 40px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #1f1f1f;
}

@media (min-width: 1029px) and (max-width: 1260px) {
  .new-header {
    padding: 0px 16px;
  }
  .new-header .header-main {
    gap: 16px;
    max-width: 100%;
  }
  .search-bar-wrapper {
    max-width: 420px;
  }
  .header-for-biz-btn {
    width: 170px !important;
  }
}

.fix-wid-cont {
  max-width: 1600px;
  width: 100%;
  justify-self: center;
}
.header-btns {
  .btn {
    background-color: #f0f7ff;
    border: 1px solid #c4dcf6;
    border-radius: 22px;
    gap: 8px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 3;
    justify-content: center;
  }
  .btn-secondary:focus,
  .btn-secondary.focus {
    color: #1f1f1f;
    background-color: #f0f7ff;
    border-color: #c4dcf6;
    box-shadow: unset;
  }

  .btn-secondary:not(:disabled):not(.disabled):active,
  .btn-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    color: #1f1f1f;
    background-color: #f0f7ff;
    border-color: #c4dcf6;
    box-shadow: unset;
  }
}
.header-center-area {
  flex: 1;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-tabs-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c4dcf6;
  border-radius: 74px;
  padding: 5px 6px;
  gap: 15px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  height: 42px;
}

.search-tabs-container.is-active {
  opacity: 1;
  pointer-events: auto;
}

.search-tab {
  background: transparent;
  border: none;
  font-family: "lato", sans-serif;
  font-size: 16px;
  color: #20639b;
  cursor: pointer;
  font-weight: 500;
  padding: 4px 15px;
  border-radius: 30px;
  transition: all 0.2s;
}

.search-tab.active {
  background: #20639b;
  color: white;
}

.search-tab:hover:not(.active) {
  background: #f0f7ff;
}

.divider {
  color: #c4dcf6;
}

.search-bar-wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(
    -37%,
    -19px
  ); /* -16px = (72px header - 40px bar) / 2, keeps it centered */
  width: 100%;
  max-width: 600px;
  transition: top 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 1400px) {
  .search-bar-wrapper {
    max-width: 450px;
  }
}

@media screen and (max-width: 1028px) {
  .search-bar-wrapper:not(.is-active) {
    display: none !important;
  }
}

.search-bar-wrapper.is-active {
  top: 37px; /* just past the bottom edge of header-center-area = below header */
  transform: translate(-37%, 0px);
  max-width: 800px;
  width: 150%;
}

.header-search {
  border: 1.5px solid #efefef;
  box-shadow: 0px 0px 1px 0px #00000008, 0px 2px 2px 0px #00000008,
    0px 4px 2px 0px #00000005, 0px 7px 3px 0px #00000000,
    0px 11px 3px 0px #00000000;
  border-radius: 74px;
  position: relative;
  width: 100%;
  max-width: 500px;
  /* padding: 8px 10px; */
  height: 40px;
  background: white;
  transition: box-shadow 0.3s ease;
  overflow: hidden;
}

.search-overlay {
  position: fixed;
  top: 149px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 90;
  height: calc(100vh - 149px);
}
.header-search .form-control {
  border: none;
  padding: 0.375rem 0.75rem 0.375rem 42px;
}
.header-search .form-control:focus {
  border-color: none;
  box-shadow: none;
}
.header-search img {
  position: absolute;
  left: 16px;
  top: 11px;
}
.header-search .form-control::placeholder {
  font-weight: 500;
  color: #c4c4c4;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  line-height: 16px;
}

/* Search Dropdown Styles */

.search-section {
  margin-bottom: 32px;
  padding-inline: 20px;
}

.search-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.clear-btn {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

.clear-btn:hover {
  color: #4a7eff;
}

.search-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.search-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f9f9f9;

  border-radius: 20px;
  padding: 4px 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #646464;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag-icon {
  width: 14px;
  height: 14px;
}

.explore-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 16px;
}

.explore-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.explore-item:hover {
  transform: translateY(-2px);
}

.explore-item:hover .explore-icon {
  background: #e3f2fd;
}

.explore-label {
  font-size: 14px;
  font-weight: 400;
  color: #2e425d;
  font-family: "Inter", sans-serif;
  margin-top: 6px;
}

.trending-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}

.trending-tag {
  background: #f0f7ff;
  border: 1px solid #c4dcf6;
  color: #20639b;
  font-family: "Inter", sans-serif;
  border-radius: 20px;
  padding: 4px 16px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
}

.trending-tag:hover {
  background: #ffffff;
  border: 1px solid #c4dcf6;
}

.extra-div {
  background: #fff;
  width: 100vw;
  height: 85px;
  position: absolute;
  left: 0;
  top: 72px;
}
.home-container {
  background: #ffffff;
  display: block;
  position: relative;
  padding: 180px 0 100px 0;
}

.scene,
.a3d {
  display: grid;
}

.scene {
  overflow: hidden;
  perspective: 105em;
  padding-top: 60px;
}

.a3d {
  place-self: center;
  transform-style: preserve-3d;
  animation: rotateY 60s linear infinite;
  transition: animation-play-state 0.3s ease;
}

/* STOP ANIMATION ON HOVER */
.a3d.paused {
  animation-play-state: paused;
}

@keyframes rotateY {
  to {
    transform: rotateY(1turn);
  }
}

/* CARD BASE */
.card {
  --w: 490px;
  --ba: calc(1turn / var(--n));
  border: none;
  grid-area: 1 / 1;
  width: var(--w);
  height: 650px;
  border-radius: 40px;
  padding: 35px;
  color: #222;
  /* box-shadow: 0 20px 40px rgba(0,0,0,0.15); */
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotateY(calc(var(--i) * var(--ba)))
    translateZ(calc(-1.1 * (0.5 * var(--w) + 1rem) / tan(0.5 * var(--ba))));

  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

/* Slight lift on hover */
.card:hover {
  transform: rotateY(calc(var(--i) * var(--ba)))
    translateZ(calc(-1.1 * (0.5 * var(--w) + 1rem) / tan(0.5 * var(--ba))))
    scale(1.05);
}

/* CONTENT */
.card-content-1 {
  text-align: center;
}

.scene .icon {
  width: 150px;
  height: 150px;
  margin-bottom: 15px;
  border-radius: 0;
  background: none;
}

.card h3 {
  font-size: 65px;
  font-family: "Inter", sans-serif;
  margin-bottom: 28px !important;
  font-weight: 500;
  line-height: 86px;
  color: #000000;
  text-align: left;
}

.card p {
  font-size: 28px;
  margin-bottom: 48px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  color: #4f4747;
  text-align: left;
}
.card-button {
  background: #fff;
  border: none;
  padding: 15px 16px;
  border-radius: 45px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0px 4px 4px 0px #00000040;
  transition: all 0.3s ease;
  color: #000000;
  width: 100%;
  font-size: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-button:hover,
.card-button:focus,
.card-button:active {
  background: #ffffff;
  background-color: #ffffff !important;
  color: #000000 !important;
  box-shadow: 0px 4px 4px 0px #00000040 !important;
}
.discover-text-pos {
  position: absolute;
  justify-self: center;
}
.discover-text-pos-2 {
  position: absolute;
  justify-self: center;
  top: 278px;
}
.head-lines {
  position: absolute;
  left: -39px;
  top: -20px;
  height: 44px;
  overflow: hidden;
  animation: popBurst 2.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;
  transform-origin: bottom center;
  /* animation: floatSpark 3s ease-in-out infinite; */
}
/* @keyframes floatSpark {
  0%,100% {
    transform: translateY(0px) scale(1);
  }
  50% {
    transform: translateY(-4px) scale(1.5);
  }
} */
@keyframes popBurst {
  0% {
    transform: scale(0) rotate(-10deg);
    opacity: 0;
  }
  30% {
    transform: scale(1.2) rotate(5deg);
    opacity: 1;
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
.icon-wrapper {
  position: relative;
  height: 40px;
  top: -43px;
}

.icon-wrapper img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  animation: rotateIcon 10s infinite;
}

/* Delay each icon */
.icon-wrapper img:nth-child(1) {
  animation-delay: 0s;
}
.icon-wrapper img:nth-child(2) {
  animation-delay: 2s;
}
.icon-wrapper img:nth-child(3) {
  animation-delay: 4s;
}
.icon-wrapper img:nth-child(4) {
  animation-delay: 6s;
}
.icon-wrapper img:nth-child(5) {
  animation-delay: 8s;
}

@keyframes rotateIcon {
  0% {
    opacity: 0;
    transform: translateX(-50%) rotateY(90deg);
  }

  10% {
    opacity: 1;
    transform: translateX(-50%) rotateY(0);
  }

  30% {
    opacity: 0;
  }

  40% {
    opacity: 0;
    transform: translateX(-50%) rotateY(-90deg);
  }

  80% {
    opacity: 0;
    transform: translateX(-50%) rotateY(-90deg);
  }

  100% {
    opacity: 0;
    transform: translateX(-50%) rotateY(-90deg);
  }
}
.main-blue-btn,
.main-blue-btn:focus,
.main-blue-btn:hover,
.main-blue-btn:active,
.show > .main-blue-btn.dropdown-toggle {
  background-color: #4a7eff;
  border-radius: 50px;
  font-size: 22px;
  font-weight: 500;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  border: none;
  padding: 10px 60px;
  box-shadow: none;
  height: fit-content;
}
.main-buttons-pos {
  width: fit-content;
  justify-content: center;
  /* left: 0px; */
  bottom: 76px;
  width: 100%;
  left: -109px;
}
.main-buttons-pos .header-btns .btn {
  font-size: 22px;
  border-radius: 50px;
}
.free-arrow {
  animation: premiumArrow 2s ease-in-out infinite;
}

@keyframes premiumArrow {
  0%,
  100% {
    transform: translateX(0) rotate(-2deg);
  }
  50% {
    transform: translateX(6px) rotate(2deg);
  }
}
.left-1 {
  position: absolute;
  left: 238px;
  top: 18px;
  animation: floatY 4s ease-in-out infinite;
}

.left-2 {
  position: absolute;
  left: 300px;
  top: 123px;
  animation: floatYReverse 5s ease-in-out infinite;
}

.left-3 {
  position: absolute;
  left: 150px;
  top: 216px;
  animation: floatY 6s ease-in-out infinite;
}

.right-1 {
  position: absolute;
  right: 173px;
  top: 15px;
  animation: floatYReverse 4.5s ease-in-out infinite;
}

.right-2 {
  position: absolute;
  right: 259px;
  top: 121px;
  animation: floatY 5.5s ease-in-out infinite;
}

.right-3 {
  position: absolute;
  right: 100px;
  top: 203px;
  animation: floatYReverse 6s ease-in-out infinite;
}

@keyframes floatY {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-18px);
  }
}

@keyframes floatYReverse {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(18px);
  }
}
.new-btn .primary-bluebtn .btn {
  border-radius: 50px;
  width: fit-content;
  padding: 20px 63px;
  background: #51cbff;
}

/* Courses Section Styles */
.courses-section {
  padding: 70px 30px 0 30px;
  background: #ffffff;
}

.courses-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 50px;
  padding-left: 82px;
}

.courses-title {
  font-size: 42px;
  font-weight: 600;
  color: #1b3755;
  font-family: "Inter", sans-serif;
  margin-bottom: 10px;
}

.courses-subtitle {
  font-family: "Satoshi", sans-serif;
  font-size: 26px;
  color: #474747;
  margin: 0;
}

.carousel-container {
  display: flex;
  align-items: center;
  position: relative;
  gap: 20px;
}

.carousel-track-wrapper {
  overflow: hidden;
  width: 100%;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.nav-btn {
  background: #ffffff1a;
  border: 1.15px solid #c4dcf6;
  border-radius: 12px;
  padding: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  z-index: 2;
  width: 45px;
  height: 150px;
}

.nav-btn:hover:not(:disabled) {
  background: #f8f9fa;
}

.nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.assessments-section {
  padding: 70px 30px;
  background-color: #ffffff;
}
.mock-interviews-section {
  padding: 70px 30px 0 30px;
  background-color: #ffffff;
}
.build-section {
  background: url("~@/assets/guestHeader/waves.png"),
    linear-gradient(
      67.34deg,
      #073787 0.46%,
      #073583 30.97%,
      #083078 58.08%,
      #0a2765 85.2%,
      #0c1c4b 111.18%,
      #0d1b49 113.44%
    );
  background-blend-mode: soft-light;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 150px;
}
.build-section .double-image {
  position: relative;
  width: 300px;
  display: flex;
  justify-content: center;
}
.build-section .double-image .one {
  position: absolute;
  top: 0;
  left: 0;
  animation: float 6s ease-in-out infinite;
}

.build-heading {
  font-family: "Manrope", sans-serif;
  font-size: 60px;
  font-weight: 800;
  line-height: 80px;
  text-align: left;
  color: #ffffff;
}
.search-dropdown-content {
  .build-heading {
    font-size: 34px;
    line-height: 40px;
  }
  .build-section .double-image {
    width: 200px;
  }
  .build-section {
    padding: 0 90px;
  }
  .double-image .one {
    top: 15px;
    left: 13px;
    height: 111px;
  }
  .double-image .two {
    height: 172px;
  }
}
/* Trusted Industry Section Styles */
.trusted-industry-section {
  padding: 20px 40px 80px 40px;
  background-color: #f8f8f8;
  text-align: center;
}

.trusted-title {
  font-family: "Inter", sans-serif;
  font-size: 42px;
  font-weight: 600;
  color: #1b3755;
  letter-spacing: 10%;
  margin-bottom: 60px;
  text-align: center;
}

.trusted-carousel-container {
  overflow: hidden;
  width: 100%;
  position: relative;
}

.trusted-carousel-track {
  display: flex;
  align-items: center;
  gap: 80px;
  animation: scroll-logos 30s linear infinite;
  width: fit-content;
  margin-top: 30px;
}

.trusted-logo-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes scroll-logos {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.trusted-carousel-track:hover {
  animation-play-state: paused;
}

/* Stats Section Styles */
.stats-section {
  padding: 80px 40px;
  background-color: #f8f8f8;
}

.stats-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
}

.stats-card-large {
  background: #ffffff;
  border-radius: 30px;
  padding: 50px 70px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.04);
  border: 1px solid #efefef;
}

.stats-tag {
  color: #4a7eff;
  font-family: "Source sans pro", sans-serif;
  font-size: 45px;
  font-weight: 500;
  line-height: 41px;
  display: block;
}

.stats-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stats-number {
  font-family: "Inter", sans-serif;
  font-size: 180px;
  font-weight: 700;
  color: #000000;
  margin: 0;
  line-height: 1;
  letter-spacing: -5px;
}

.avatar-group {
  display: flex;
  align-items: center;
  /* perspective: 1000px; */
}

.stats-avatars {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.stats-avatars.animate-popout {
  opacity: 1;
  animation: popout 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes popout {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  70% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.avatar-circle {
  position: relative;
  margin-left: -45px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.avatar-circle:nth-child(2) {
  z-index: 2;
}
.avatar-circle:nth-child(3) {
  z-index: 1;
}

.avatar-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-accessory {
  position: absolute;
  z-index: 10;
  pointer-events: none;
}

.avatar-accessory img {
  width: 55px;
  height: auto;
  animation: float-shake 4s ease-in-out infinite;
}

@keyframes float-shake {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-6px) rotate(-4deg);
  }
  50% {
    transform: translateY(0) rotate(0deg);
  }
  75% {
    transform: translateY(-6px) rotate(4deg);
  }
}

.avatar-accessory.laptop {
  top: 4px;
  left: 0px;
}

.avatar-accessory.briefcase {
  bottom: 0px;
  left: 26px;
  animation-delay: 0.5s;
}

.avatar-accessory.sparkles {
  top: 4px;
  right: 12px;
  animation-delay: 1s;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.stats-card-small {
  background: #ffffff;
  border-radius: 30px;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.04);
  border: 1px solid #efefef;
  transition: all 0.3s ease;
}

.stats-card-small:hover {
  transform: translateY(-10px);
  box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.08);
}

.stats-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.stats-icon-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.stats-small-number {
  font-family: "Inter", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: #000000;
  letter-spacing: 10%;
  margin: 0;
  line-height: 1;
}

.stats-small-label {
  font-family: "Source sans pro", sans-serif;
  font-size: 25px;
  color: #4a7eff;
  font-weight: 500;
  margin: 10px 0 0 0;
}

/* FAQ Section Styling */
.faq-section {
  padding: 80px 30px;
  background-color: #fcfdfe; /* Very light subtle blue-white */
}

.faq-container {
  display: flex;
  gap: 80px;
  align-items: flex-start;
}

.faq-info {
  flex: 1;
  max-width: 450px;
}

.faq-title {
  font-family: "Inter", sans-serif;
  font-size: 42px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 24px !important;
}
.color-homepage-font {
  background: linear-gradient(180deg, #102133 0%, #4c78ce 100%);
  /* backdrop-filter: blur(2px);  Parent transparency needed */
  background-clip: text; /* Standard property */
  -webkit-background-clip: text; /* WebKit-specific property for compatibility */
  -webkit-text-fill-color: transparent; /* WebKit-specific for text transparency */
  color: transparent; /* Fallback for unsupported browsers */
  z-index: 1;
  position: relative;
}
.faq-desc {
  font-family: "Source sans pro", sans-serif;
  font-size: 25px;
  font-weight: 400;
  color: #474747;
  line-height: 1.6;
  margin-bottom: 40px;
}

.contact-wrapper {
  position: relative;
}

.contact-btn {
  background-color: #f0f5ff;
  border: 1px solid #dde7ff;
  color: #1a335e;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 14px 28px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;
  position: relative;
}

.contact-btn:hover {
  background-color: #e6eeff;
  border-color: #4a7eff;
  transform: translateY(-2px);
}

.btn-arrow {
  background-color: #4a7eff;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-arrow img {
  width: 12px;
  height: 12px;
}

.decorative-line {
  position: absolute;
  top: 50%;
  left: 0;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
  width: 0;
  animation: growWidth 4s linear infinite;
}

.decorative-line img {
  width: 400px;
  display: block;
}

@keyframes growWidth {
  0% {
    width: 0;
  }
  50% {
    width: 400px;
  }
  100% {
    width: 0;
  }
}

/* Accordion Styling */
.faq-accordion {
  flex: 1.2;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 26px;
  padding: 10px;
  background-color: #f8f8f8;
}

.faq-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  cursor: pointer;
  border: 1px solid transparent;
}

.faq-card.active {
  background-color: #ffffff;
  border-color: #e6eeff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transform: translateX(0);
}

.faq-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.faq-question {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  margin: 0;
}

.faq-toggle-icon {
  width: 28px;
  height: 28px;
  background-color: #4a7eff;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 400;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}
.faq-toggle-icon .active {
  transform: rotate(45deg);
}
.faq-body {
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.faq-answer {
  font-family: "Inter", sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.7;
  color: #5e5e5e;
  margin: 20px 0 0 0;
  padding-top: 20px;
}

.career-match-section {
  position: relative;
  /* padding: 120px 20px; */
  height: 400px;
  text-align: center;
  color: white;
  overflow: hidden;

  background: linear-gradient(180deg, #082433 0%, #071e2c 50%, #051924 100%);
}
.career-match-section .bg-img {
  position: absolute;
  width: 100vw;
  z-index: 1;
  top: 0;
  left: 0;
}
.career-match-section .bg-img img {
  width: 100%;
  height: 400px;
}
.career-match-section .content {
  align-content: center;
  height: 100%;
}
.career-match-section .content h2 {
  position: relative;
  z-index: 3;
  font-family: "manrope", sans-serif;
  font-size: 62px;
  font-weight: 800;

  background: linear-gradient(180deg, #f6f6f7 0%, #7e808f 100%);
  /* backdrop-filter: blur(2px);  Parent transparency needed */
  background-clip: text; /* Standard property */
  -webkit-background-clip: text; /* WebKit-specific property for compatibility */
  -webkit-text-fill-color: transparent; /* WebKit-specific for text transparency */
  color: transparent; /* Fallback for unsupported browsers */
  z-index: 1;
  position: relative;
  margin-bottom: 0px;
}
.career-match-section .content p {
  font-family: "source sans pro", sans-serif;
  font-size: 22px;
  font-weight: 400;
  color: #ffffff;
  margin-block: 25px;
}
.floating-icons {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
}

.h-icon {
  position: absolute;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
  100% {
    transform: translateY(0px);
  }
}
.i1 {
  top: 20%;
  left: 8%;
  animation-delay: 0s;
}
.i2 {
  top: 76%;
  left: 5%;
  animation-delay: 1s;
}
.i3 {
  bottom: 3%;
  left: 17%;
  animation-delay: 2s;
}
.i4 {
  top: 46%;
  left: 22%;
  animation-delay: 3s;
}
.i5 {
  top: 11%;
  right: 20%;
  animation-delay: 2s;
}
.i6 {
  bottom: 60%;
  right: 8%;
  animation-delay: 1s;
}
.i7 {
  top: 69%;
  right: 5%;
  animation-delay: 3s;
}
.i8 {
  bottom: 2%;
  right: 15%;
  animation-delay: 2.5s;
}

/* ============================================================
   NOTIFICATION SLIDE PANEL
   ============================================================ */

/* Bell button cursor */
.header-page-notif-bell {
  cursor: pointer;
  margin-right: 40px;
}

/* Panel: slides in from the right */
.notif-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 380px;
  max-width: 95vw;
  height: 100vh;
  background: #ffffff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.12);
  border-radius: 20px 0 0 20px;
  overflow: hidden;
}

/* Panel header row */
.notif-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.notif-panel-title {
  font-family: "Inter", sans-serif;
  font-size: 19px;
  font-weight: 600;
  color: #2e425d;
}

.notif-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #888;
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;
}
.notif-close-btn:hover {
  background: #f3f4f6;
  color: #333;
}

/* Scrollable card list */
.notif-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Individual notification card */
.notif-card {
  position: relative;
  background: #ffffff;

  padding: 16px 40px 16px 16px;

  transition: box-shadow 0.2s ease;
  border-bottom: 1px solid #efefef;
}
.notif-card:hover {
  box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.15) !important;
  z-index: 1;
}

/* Dismiss ✕ button top-right of card */
.notif-dismiss {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  font-size: 14px;
  color: #aaa;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
  line-height: 1;
  transition: background 0.2s, color 0.2s;
}
.notif-dismiss:hover {
  background: #f3f4f6;
  color: #555;
}

/* Card body: avatar + text */
.notif-card-body {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.notif-card-body.pointer {
  cursor: pointer;
}

.notif-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid #e8eeff;
}

.notif-text {
  flex: 1;
}

.notif-name {
  font-family: "Inter", sans-serif;
  font-size: 19px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 4px;
}

.notif-msg {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #4d4d4d;
  margin: 0 0 10px;
  line-height: 1.5;
}

/* CTA button inside card */
.notif-cta {
  background: #20639b;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 7px 20px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}
.notif-cta:hover {
  background: #174f7a;
}
.notif-cta:active {
  background: #174f7a;
}
.notif-cta:focus {
  background: #20639b;
  outline: none;
}

/* Empty state */
.notif-empty {
  text-align: center;
  padding: 60px 20px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: #9ca3af;
}

/* Dimming overlay behind the panel */
.notif-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 9998;
}

/* ── Vue transition: slide from right ── */
.notif-slide-enter-active,
.notif-slide-leave-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.notif-slide-enter,
.notif-slide-leave-to {
  transform: translateX(100%);
}

/* ============================================================
   MOBILE CAROUSEL → SWIPE + AUTO-SCROLL  (≤ 1028px)
   ============================================================ */

/* Always hide mobile marquee on desktop */
.mobile-marquee-container {
  display: none;
}

/* Always show desktop carousel */
.desktop-only-carousel {
  display: flex;
}

/* Error class for input field */
.error {
  border: 1px solid#DC143C !important;
  border-radius: 25px !important;
  box-shadow: unset !important;
}

/* Class for error text */
.invalid-msg-txt {
  color: #dc143c;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

/* Responsive styles for search dropdown */
@media (max-width: 1028px) {
  .search-dropdown-content {
    padding: 0px;
    padding-top: 0px;
    box-shadow: none;
    max-height: calc(100dvh - 168px);
    min-height: auto;
    width: 100% !important;
    box-shadow: 133px 38px 56px -30px rgba(0, 0, 0, 0.01),
      75px 22px 47px -25px rgba(0, 0, 0, 0.05),
      33px 10px 35px -20px rgba(0, 0, 0, 0.09),
      8px 2px 19px -10px rgba(0, 0, 0, 0.1);
  }

  .explore-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .search-tags {
    gap: 8px;
  }

  .trending-tags {
    gap: 8px;
  }

  .search-tag,
  .trending-tag {
    font-size: 12px;
    padding: 6px 12px;
  }
  .build-heading {
    font-size: 22px;
    line-height: 31px;
  }
  .build-section .double-image .one {
    height: 100px;
  }
  .build-section .double-image .two {
    height: 160px;
  }
  .build-section {
    padding: 0 30px;
  }
  .stats-tag {
    font-size: 12px;
  }
  .stats-number {
    font-size: 60px;
  }
  .stats-icon-box {
    height: 35px;
    margin-bottom: 2px;
  }
  .stats-small-number {
    font-size: 14px;
  }
  .stats-small-label {
    font-size: 12px;
    margin-top: 1px;
  }
  .trusted-title {
    font-size: 20px;
  }
  .trusted-logo-item img {
    height: 40px;
  }
  .faq-title {
    font-size: 32px;
    margin-bottom: 9px !important;
    padding-inline: 20px;
  }
  .faq-container {
    flex-direction: column;
    gap: 30px;
  }
  .stats-section {
    padding: 15px;
  }
  .stats-container {
    gap: 8px;
  }
  .stats-grid {
    gap: 8px;
  }
  .stats-card-large {
    border-radius: 8px;
    padding: 15px;
  }
  .avatar-circle {
    height: 63px;
    margin-left: -23px;
  }
  .avatar-accessory img {
    width: 20px;
  }
  .avatar-accessory.briefcase {
    bottom: -9px;
  }
  .avatar-accessory.sparkles {
    right: 0px;
  }
  .stats-tag {
    line-height: 29px;
  }
  .stats-card-small {
    border-radius: 8px;
    padding: 15px;
  }
  .trusted-industry-section {
    padding: 20px 0px 30px 0px;
  }
  .trusted-carousel-track {
    gap: 40px;
  }
  .faq-section {
    padding: 20px;
  }
  .faq-desc {
    font-size: 16px;
    margin-bottom: 15px;
    padding-inline: 20px;
  }
  .faq-question {
    font-size: 14px;
  }
  .faq-answer {
    font-size: 12px;
  }
  .faq-toggle-icon {
    width: 10px;
    height: 10px;
  }
  .faq-toggle-icon img {
    width: 10px;
    height: 10px;
  }
  .faq-card {
    border-radius: 14px;
    padding: 15px 20px;
  }
  .faq-accordion {
    border-radius: 14px;
  }
  .career-match-section .content h2 {
    font-size: 40px;
  }
  .career-match-section .content p {
    font-size: 16px;
  }
  .h-icon {
    opacity: 0.5;
  }

  .scene {
    overflow-x: auto !important; /* Changed from hidden to auto to allow swiping */
    overflow-y: visible !important;
    display: block !important;
    padding: 20px 0 !important;
    perspective: none !important;
    position: relative;
    width: 100%;
    -webkit-overflow-scrolling: touch; /* Smooth momentum scroll */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
  }
  .scene::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome/Safari */
  }
  .a3d {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: max-content !important;
    gap: 20px !important;
    transform: none !important;
    animation: none !important;
    place-self: unset !important;
    padding: 20px 0 !important;
  }
  .a3d > *:last-child {
    margin-right: 20px; /* Accounts for the gap at the end of the duplicated list */
  }
  .card {
    position: relative !important;
    grid-area: unset !important;
    flex-shrink: 0 !important;
    transform: rotate(
      0deg
    ) !important; /* Counter-rotates cards to keep them upright */
    width: 240px !important;
    height: 307px !important;
    padding: 30px 10px !important;
    border-radius: 32px !important;
    margin: 0 !important;
  }
  .card-button {
    font-size: 16px;
    border-radius: 45px;
    padding: 12px 20px !important;
  }
  .card-button img {
    display: none;
  }
  .scene .icon {
    height: 100px;
    width: 100px;
    margin-bottom: 5px;
  }
  .card h3 {
    font-size: 31px;
    line-height: 35px;
    margin-bottom: 10px !important;
  }
  .card p {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .discover-text-pos-2 {
    top: 213px;
  }
  .main-buttons-pos {
    left: unset;
    bottom: 34px;
  }
  .main-blue-btn {
    font-size: 16px;
    padding: 13px 31px;
    background-color: #20639b;
  }
  .main-blue-btn:focus,
  .main-blue-btn:hover,
  .main-blue-btn:active {
    background-color: #20639b;
  }
  .search-overlay {
    display: none;
  }
  .extra-div {
    background: #f7f7f7;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
  }
  .search-bar-wrapper.is-active {
    top: 80px !important;
    max-width: 100%;
    width: 100%;
  }
  .search-dropdown-content {
    width: 100%;
  }
  .search-bar-wrapper {
    position: fixed;
    padding: 0;
    background-color: #ffffff;
    pointer-events: auto;
    box-shadow: 8px 2px 19px 0px #0000001a, 33px 10px 35px 0px #00000017,
      75px 22px 47px 0px #0000000d, 133px 38px 56px 0px #00000003,
      208px 60px 61px 0px #00000000;
    /* transform: translateX(-50%); */
    transform: unset !important;
    width: 95% !important;
    left: 11px;
    border-radius: 20px 20px 0 0;
  }
  .search-tabs-container.is-active {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    pointer-events: auto;
    height: unset;
  }
  .header-center-area {
    position: fixed;
    width: 100%;
    left: 0;
    padding: 15px;
    pointer-events: none;
  }
  .search-tab {
    font-size: 16px;
    padding: 4px;
    flex: 1;
    text-align: center;
    line-height: 2;
  }
  .search-tabs-container {
    width: 95%;
    gap: 10px;
    transition: none !important;
  }
  .header-search .form-control::placeholder {
    font-weight: 500;
    color: #909090;
    font-size: 16px;
    font-family: "Inter", sans-serif;
  }
  .section-title {
    font-size: 16px;
    color: #344054;
  }
  .section-header {
    justify-content: space-between;
  }
  .explore-icon img {
    height: 75px;
  }
  .search-section {
    padding-inline: 5px;
  }
  .search-section .hor-line {
    background-color: #d6d6d6;
    flex: 1;
    height: 1px;
  }
  .search-dropdown-content {
    .build-heading {
      font-size: 20px;
      line-height: 27px;
    }
    .build-section {
      padding: 0 20px;
    }
    .build-section .double-image .two {
      height: 90px;
    }
    .build-section .double-image .one {
      height: 54px;
    }
    .build-section .double-image {
      width: 176px;
    }
    .mob-hor-scroll {
      width: 100%;
      overflow-x: auto;
    }
    .mob-hor-scroll::-webkit-scrollbar {
      display: none;
    }
    .mob-hor-scroll .search-tags {
      height: 80px;
      width: 200vw;
    }
    .mob-hor-scroll .trending-tags {
      height: 80px;
      width: 200vw;
    }
  }
  .header-search {
    padding: 2px;
    overflow: hidden;
    flex: 1;
  }
  .header-search img {
    left: 19px;
    top: 14px;
  }
  .shadow {
    border-radius: 50%;
  }
  .head-div .logo {
    height: 20px;
  }
  .courses-header {
    padding-left: 0;
    margin-bottom: 0;
  }
  .courses-section .header-btns .btn,
  .assessments-section .header-btns .btn,
  .mock-interviews-section .header-btns .btn,
  .contact-wrapper .header-btns .btn {
    width: 90%;
    justify-content: center;
    justify-self: anchor-center;
    border-radius: 12px;
  }

  .left-1 {
    height: 40px;
    left: 320px;
    top: 34px;
  }

  .left-2 {
    height: 40px;
    left: 50px;
    top: 1px;
  }

  .left-3 {
    height: 40px;
    left: 44px;
    bottom: 36px;
    top: unset;
  }

  .right-1 {
    height: 40px;
    right: 68px;
    top: unset;
    bottom: 62px;
  }

  .right-2 {
    height: 40px;
    right: 259px;
    top: 140px;
  }

  .right-3 {
    height: 40px;
    right: 100px;
    top: 203px;
  }
  .mob-flex {
    flex-direction: column;
    align-items: center;
  }
  .scroll-down {
    height: 47px;
    width: 47px;
    transform: rotate(-90deg);
  }
  .mobsearchpadding {
    padding: 15px 15px 15px 15px;
  }
}

@media (max-width: 1028px) {
  /* Hide desktop arrow carousel */
  .desktop-only-carousel {
    display: none !important;
  }

  /* Container: scrollable viewport — enables native touch scroll */
  .mobile-marquee-container {
    display: block;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    width: 100%;
  }

  .mob-main-marquee {
    display: block;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    width: 107%;
    left: -13px;
    transform: rotate(-5deg);
  }
  /* Hide scrollbar on Webkit */
  .mobile-marquee-container::-webkit-scrollbar {
    display: none;
  }

  /* Track: just a horizontal flex row — JS drives scrollLeft */
  .mobile-marquee-track {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    width: max-content;
    padding: 8px 0;
  }

  /* Cards should not shrink */
  .mobile-marquee-track > * {
    flex-shrink: 0;
  }

  /* Card widths per section */
  .courses-section .mobile-marquee-track > * {
    width: 260px;
  }

  .assessments-section .mobile-marquee-track > * {
    width: 280px;
  }

  .mock-interviews-section .mobile-marquee-track > * {
    width: 185px;
  }

  /* Sections: left padding, right bleeds to edge */
  .courses-section,
  .assessments-section,
  .mock-interviews-section {
    padding-left: 12px;
    padding-right: 12px;
  }
  .for-mob-height {
    height: 460px;
    margin-top: 60px;
  }
  .icon-wrapper {
    top: -57px;
  }
  .home-container {
    padding: 165px 0 85px 0;
    overflow: hidden;
  }
  .notif-panel {
    position: fixed;
    top: 72px;
    right: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: calc(100dvh - 150px);
    background: #ffffff;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    border-radius: 0;
    overflow: hidden;
  }
  .notif-overlay {
    position: fixed;
    inset: 0;
    background: unset;
    z-index: 1060;
  }
  .new-header {
    z-index: 1061;
  }
  .notif-list {
    flex: unset;
    height: calc(100dvh - 210px);
  }
}
</style>
